import { useEffect, useMemo, useState } from "react";
import { VideoSegmentsData } from "@/features/player/api/types";
import { langToLangApi } from "@/shared/const/locale";
import { getBuildFullWithoutPauseApi } from "@/features/player/api/segmants";

interface UseDataProps {
    mediaId: string;
    lang: string;
}

export const useVideoSegments = ({ mediaId, lang }: UseDataProps) => {
    const [data, setData] = useState<VideoSegmentsData>();

    useEffect(() => {
        const getData = async () => {
            try {
                const data = await getBuildFullWithoutPauseApi({
                    mediaId,
                    lang: langToLangApi[lang],
                });
                setData(data);
            } catch (error) {
                console.log("load data error", error);
            }
        };
        if (lang) {
            getData();
        }
    }, [mediaId, lang]);

    return { videoUrls: data?.hls, subtitles: data?.segments };
};
